import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from './queryKeys'
import { retrieveOptions } from './views'

export const useProfileOptions = () => {
  const options = useQuery({
    queryKey: QueryKeys.options.key,
    queryFn: retrieveOptions,
    refetchOnMount(q) {
      return q.state.dataUpdateCount == 0
    },
  })

  return options
}
